import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitopunecab() {



  const cardData = {


  keyword: "Navi Mumbai to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Navi Mumbai to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, industrial visits, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a comfortable journey from Navi Mumbai to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Navi Mumbai to Pune taxi services.",

  topPlaces: [
    {
      title: "Hinjewadi Phase 1",
      description: "Hinjewadi Phase 1 is a major IT and corporate destination in Pune, housing multinational companies, software firms, startups, and business parks. It is a preferred location for professionals traveling from Navi Mumbai for corporate work."
    },
    {
      title: "Mahape MIDC",
      description: "Mahape MIDC is one of Navi Mumbai's important technology and industrial areas, featuring IT companies, manufacturing units, corporate offices, and business parks. It connects strongly with Pune's industrial and corporate travel requirements."
    },
    {
      title: "EON IT Park Kharadi",
      description: "EON IT Park Kharadi is one of Pune's leading technology hubs, home to global companies, IT firms, financial organizations, and modern office spaces. It attracts professionals and business travelers throughout the year."
    },
    {
      title: "Chakan Industrial Area",
      description: "Chakan Industrial Area is a major manufacturing and logistics hub near Pune, known for automobile companies, engineering industries, warehouses, and large production facilities. It is an important destination for industrial travel."
    },
    {
      title: "Talegaon MIDC",
      description: "Talegaon MIDC is an emerging industrial zone near Pune featuring automobile companies, manufacturing plants, logistics centers, and corporate units. It is frequently visited by business professionals and industrial teams."
    },
    {
      title: "Balewadi",
      description: "Balewadi is a growing commercial and lifestyle destination in Pune, known for Balewadi High Street, business spaces, premium residential projects, restaurants, and entertainment options."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is one of Pune's most famous historical landmarks, known for Maratha heritage, grand architecture, and cultural importance. It attracts tourists and history enthusiasts from across India."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic monument in Pune recognized for its beautiful architecture and association with India's freedom movement. It is a popular sightseeing destination for visitors."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and green valleys. It is a popular weekend destination for families, couples, and nature lovers."
    },
    {
      title: "Imagica Theme Park",
      description: "Imagica Theme Park near Khopoli is a popular entertainment destination featuring thrilling rides, themed attractions, and family-friendly activities. It is a favorite leisure stop for travelers on the Mumbai-Pune route."
    }
  ],






"services": [
  {
    "name": "Navi Mumbai to Pune Taxi",
    "description": "Book Navi Mumbai to Pune Taxi for comfortable intercity travel with professional chauffeurs, clean AC vehicles, affordable fares, doorstep pickup, and reliable service. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Navi Mumbai to Pune Taxi Fare",
    "description": "Check Navi Mumbai to Pune Taxi Fare with transparent pricing, fixed rates, multiple vehicle options, and comfortable chauffeur-driven travel without hidden charges."
  },
  {
    "name": "Navi Mumbai to Pune One Way Taxi",
    "description": "Choose Navi Mumbai to Pune One Way Taxi for direct drop service with affordable pricing, professional drivers, clean vehicles, and convenient travel."
  },
  {
    "name": "Navi Mumbai to Pune Innova Taxi",
    "description": "Book Navi Mumbai to Pune Innova Taxi for spacious and comfortable travel with premium interiors, AC comfort, luggage space, and experienced chauffeurs."
  },
  {
    "name": "Navi Mumbai to Pune Ertiga Taxi",
    "description": "Travel with Navi Mumbai to Pune Ertiga Taxi offering comfortable seating, affordable fares, professional drivers, and reliable family transportation."
  },
  {
    "name": "Navi Mumbai to Pune Sedan Cab",
    "description": "Choose Navi Mumbai to Pune Sedan Cab for economical and comfortable travel with well-maintained cars, trained chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Navi Mumbai to Pune Round Trip Cab",
    "description": "Book Navi Mumbai to Pune Round Trip Cab with flexible return timing, premium vehicles, affordable packages, and reliable chauffeur service."
  },
  {
    "name": "Navi Mumbai to Hinjewadi Cab",
    "description": "Reserve Navi Mumbai to Hinjewadi Cab for corporate and IT travel with punctual pickup, comfortable AC vehicles, and professional drivers."
  },
  {
    "name": "Navi Mumbai to Pune Cab",
    "description": "Book Navi Mumbai to Pune Cab for safe and convenient transportation with premium vehicles, experienced chauffeurs, transparent pricing, and 24x7 support."
  },
  {
    "name": "Pune to Navi Mumbai Cab",
    "description": "Choose Pune to Navi Mumbai Cab for return travel with doorstep pickup, clean vehicles, affordable fares, and dependable intercity service."
  },
  {
    "name": "Cab Service in Navi Mumbai",
    "description": "Get Cab Service in Navi Mumbai for local and outstation travel with professional chauffeurs, AC cars, affordable rates, and reliable customer support."
  },
  {
    "name": "Cab Hire in Navi Mumbai",
    "description": "Hire Cab in Navi Mumbai with premium vehicles, experienced drivers, flexible booking options, and comfortable travel solutions."
  },
  {
    "name": "Cab Service in Airoli",
    "description": "Book Cab Service in Airoli for airport transfers, corporate trips, and outstation journeys with clean vehicles and professional chauffeurs."
  },
  {
    "name": "Cabs in Navi Mumbai",
    "description": "Choose Cabs in Navi Mumbai for reliable transportation with Sedan, Ertiga, Innova Crysta, SUV, and premium car options."
  },
  {
    "name": "Kharghar Taxi Service",
    "description": "Book Kharghar Taxi Service with comfortable vehicles, trained drivers, affordable fares, and convenient pickup facilities."
  },
  {
    "name": "Navi Mumbai Taxi Service",
    "description": "Our Navi Mumbai Taxi Service provides safe and affordable travel with professional drivers, clean AC cars, and flexible booking options."
  },
  {
    "name": "Taxi Service in Vashi Navi Mumbai",
    "description": "Get Taxi Service in Vashi Navi Mumbai for business travel, family trips, airport transfers, and outstation journeys with reliable vehicles."
  },
  {
    "name": "Innova Crysta on Rent in Navi Mumbai",
    "description": "Book Innova Crysta on Rent in Navi Mumbai for premium group travel with spacious seating, luxury comfort, and experienced chauffeurs."
  },
  {
    "name": "Ertiga on Rent in Navi Mumbai",
    "description": "Choose Ertiga on Rent in Navi Mumbai for family trips, airport transfers, and outstation travel with affordable pricing."
  },
  {
    "name": "Outstation Cabs in Navi Mumbai",
    "description": "Book Outstation Cabs in Navi Mumbai for long-distance journeys with premium cars, professional drivers, transparent fares, and safe travel."
  },
  {
    "name": "Navi Mumbai to Pune Cab Service",
    "description": "Our Navi Mumbai to Pune Cab Service offers one-way and round-trip travel with punctual pickup, comfortable vehicles, and reliable chauffeur support."
  },
  {
    "name": "Navi Mumbai to Pune Taxi Service",
    "description": "Choose Navi Mumbai to Pune Taxi Service for affordable fares, AC vehicles, experienced drivers, and smooth intercity transportation."
  },
  {
    "name": "Navi Mumbai to Pune Cab Booking",
    "description": "Complete Navi Mumbai to Pune Cab Booking online with instant confirmation, multiple vehicle choices, fixed pricing, and easy reservation."
  },
  {
    "name": "Cab from Navi Mumbai to Pune",
    "description": "Hire Cab from Navi Mumbai to Pune with comfortable seating, luggage space, professional chauffeurs, and safe highway travel."
  },
  {
    "name": "Navi Mumbai to Pune Car Rental",
    "description": "Choose Navi Mumbai to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium cars for private and corporate travel."
  },
  {
    "name": "Navi Mumbai to Pune One Way Cab",
    "description": "Book Navi Mumbai to Pune One Way Cab for direct travel with affordable fares, clean vehicles, and professional drivers."
  },
  {
    "name": "Cheap Navi Mumbai to Pune Cab",
    "description": "Select Cheap Navi Mumbai to Pune Cab with budget-friendly pricing, comfortable cars, and dependable transportation."
  },
  {
    "name": "Book Navi Mumbai to Pune Cab Online",
    "description": "Book Navi Mumbai to Pune Cab Online with quick confirmation, easy booking, flexible schedules, and trusted chauffeur service."
  },
  {
    "name": "Navi Mumbai Airport to Pune Cab",
    "description": "Reserve Navi Mumbai Airport to Pune Cab for airport transfers with timely pickup, AC vehicles, luggage assistance, and professional drivers."
  },
  {
    "name": "Navi Mumbai to Pune Outstation Cab",
    "description": "Travel with Navi Mumbai to Pune Outstation Cab featuring safe highway journeys, premium vehicles, experienced chauffeurs, and affordable packages."
  },
  {
    "name": "24x7 Navi Mumbai to Pune Taxi Service",
    "description": "Get 24x7 Navi Mumbai to Pune Taxi Service with round-the-clock booking support, reliable cars, professional drivers, and comfortable travel."
  },
  {
    "name": "Best Navi Mumbai to Pune Cab Service",
    "description": "Choose Best Navi Mumbai to Pune Cab Service for reliable transportation with premium vehicles, experienced chauffeurs, transparent fares, and customer satisfaction."
  }
],

"tableData": [
  ["Navi Mumbai to Pune Taxi", "Navi Mumbai to Pune Taxi Fare"],
  ["Navi Mumbai to Pune One Way Taxi", "Navi Mumbai to Pune Innova Taxi"],
  ["Navi Mumbai to Pune Ertiga Taxi", "Navi Mumbai to Pune Sedan Cab"],
  ["Navi Mumbai to Pune Round Trip Cab", "Navi Mumbai to Hinjewadi Cab"],
  ["Navi Mumbai to Pune Cab", "Pune to Navi Mumbai Cab"],
  ["Cab Service in Navi Mumbai", "Cab Hire in Navi Mumbai"],
  ["Cab Service in Airoli", "Cabs in Navi Mumbai"],
  ["Kharghar Taxi Service", "Navi Mumbai Taxi Service"],
  ["Taxi Service in Vashi Navi Mumbai", "Innova Crysta on Rent in Navi Mumbai"],
  ["Ertiga on Rent in Navi Mumbai", "Outstation Cabs in Navi Mumbai"],
  ["Navi Mumbai to Pune Cab Service", "Navi Mumbai to Pune Taxi Service"],
  ["Navi Mumbai to Pune Cab Booking", "Cab from Navi Mumbai to Pune"],
  ["Navi Mumbai to Pune Car Rental", "Navi Mumbai to Pune One Way Cab"],
  ["Cheap Navi Mumbai to Pune Cab", "Book Navi Mumbai to Pune Cab Online"],
  ["Navi Mumbai Airport to Pune Cab", "Navi Mumbai to Pune Outstation Cab"],
  ["24x7 Navi Mumbai to Pune Taxi Service", "Best Navi Mumbai to Pune Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Navi Mumbai to Pune cab services with comfortable vehicles, experienced drivers, and smooth intercity travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Navi Mumbai",
    WhyChoosedescription: "Get doorstep pickup from Vashi, Nerul, Belapur, Kharghar, Panvel, offices, hotels, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe Travel Through Expressway Route",
    WhyChoosedescription: "Our professional chauffeurs ensure a secure and comfortable journey with excellent knowledge of the Navi Mumbai-Pune route."
  },
  {
    WhyChooseheading: "Premium Cars for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your passenger count and comfort preference."
  },
  {
    WhyChooseheading: "Transparent Navi Mumbai Pune Cab Fare",
    WhyChoosedescription: "Enjoy competitive pricing with clear fare details and no hidden charges before confirming your cab booking."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Book flexible one-way cabs, return trips, or customized travel packages according to your travel schedule."
  },
  {
    WhyChooseheading: "Ideal for Airport & Corporate Travel",
    WhyChoosedescription: "Our Navi Mumbai to Pune cabs are suitable for airport transfers, business meetings, office travel, family trips, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Get quick booking support, instant confirmation, and reliable customer assistance whenever you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Navi Mumbai to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Navi Mumbai to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Navi Mumbai to Pune?",
    answer: "Yes, one-way cab services are available from Navi Mumbai to Pune with flexible pickup and drop options."
  },
  {
    question: "Which areas in Navi Mumbai are covered for pickup?",
    answer: "We provide pickup from Vashi, Nerul, Belapur, Kharghar, Panvel, and other major locations across Navi Mumbai."
  },
  {
    question: "Which vehicles are available for Navi Mumbai to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is Navi Mumbai to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for convenient travel at any preferred time."
  },
  {
    question: "Can I book Navi Mumbai to Pune airport transfer cab?",
    answer: "Yes, we provide airport transfer services from Navi Mumbai and nearby areas to Pune Airport."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I schedule my Navi Mumbai to Pune cab before travel?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide cabs for corporate travel between Navi Mumbai and Pune?",
    answer: "Yes, our services are suitable for corporate executives, employee transportation, meetings, and business travel."
  },
  {
    question: "How can I book Navi Mumbai to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshmukh",
    feedback: "The Navi Mumbai to Pune cab service was excellent with smooth coordination, a comfortable vehicle, and a professional driver. The complete journey was safe and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Nair",
    feedback: "Trustline Travels delivered a great travel experience with easy booking, timely pickup, and excellent service quality. The ride from Navi Mumbai to Pune was comfortable and relaxing.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/navi-mumbai-to-pune-cab.webp",
  "description": "Book Navi Mumbai to Pune cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Navi Mumbai to Pune with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8392"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/navi-mumbai-to-pune-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Navi Mumbai to Pune Cab | One Way & Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Pune cab service with Trustline Travels for reliable and affordable intercity travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="navi mumbai to pune taxi, navi mumbai to pune taxi fare, navi mumbai to pune one way taxi, navi mumbai to pune innova taxi, navi mumbai to pune ertiga taxi, navi mumbai to pune sedan cab, navi mumbai to pune round trip cab, navi mumbai to hinjewadi cab, Navi Mumbai to Pune Cab, Navi Mumbai Pune Taxi Service, Navi Mumbai Pune One Way Cab, Navi Mumbai Pune Airport Taxi, Navi Mumbai Pune Outstation Cab, Navi Mumbai Pune Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/101.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitopunecab;